"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPaymentQueueUpdatedContract = exports.ExternalPaymentQueueCreatedContract = exports.ExternalPaymentQueueEventDataContract = exports.ExternalPaymentQueueLine = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
const homi_shared_1 = require("@getgreenline/homi-shared");
class ExternalPaymentQueueLine {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueLine.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "paymentQueueId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueLine.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "discountId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "discountPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "discountPercentage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueLine.prototype, "discountMessage", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueLine.prototype, "price", void 0);
exports.ExternalPaymentQueueLine = ExternalPaymentQueueLine;
class ExternalPaymentQueueEventDataContract {
}
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ExternalPaymentQueueEventDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueEventDataContract.prototype, "customerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueEventDataContract.prototype, "customerName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueEventDataContract.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueEventDataContract.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentQueueEventDataContract.prototype, "orderType", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueEventDataContract.prototype, "totalDiscrepancy", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentQueueEventDataContract.prototype, "paymentLinesTotalDiscrepancy", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ExternalPaymentQueueEventDataContract.prototype, "paymentLines", void 0);
exports.ExternalPaymentQueueEventDataContract = ExternalPaymentQueueEventDataContract;
class ExternalPaymentQueueCreatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.paymentQueue = events_1.GreenlineEvent.create(ExternalPaymentQueueEventDataContract, params.paymentQueue);
    }
}
exports.ExternalPaymentQueueCreatedContract = ExternalPaymentQueueCreatedContract;
class ExternalPaymentQueueUpdatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.paymentQueue = events_1.GreenlineEvent.create(ExternalPaymentQueueEventDataContract, params.paymentQueue);
    }
}
exports.ExternalPaymentQueueUpdatedContract = ExternalPaymentQueueUpdatedContract;
//# sourceMappingURL=payment-queues.js.map